import React from 'react';

const BudgetRangeFilter = ({ filters, updateBudgetFilter }) => {
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Budget Range</h3>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <label htmlFor="min-budget" className="block text-xs text-gray-500 dark:text-gray-400">
            Min ($)
          </label>
          <input
            type="number"
            id="min-budget"
            name="min-budget"
            value={filters.minBudget}
            onChange={(e) => updateBudgetFilter('minBudget', e.target.value)}
            className="mt-1 block w-full rounded-md ring-1 ring-inset ring-gray-300 dark:ring-gray-600 py-1.5 px-3 text-sm text-gray-900 dark:text-white shadow-sm focus:ring-2 focus:ring-inset focus:ring-indigo-600 dark:bg-gray-700"
            placeholder="0"
          />
        </div>
        <div>
          <label htmlFor="max-budget" className="block text-xs text-gray-500 dark:text-gray-400">
            Max ($)
          </label>
          <input
            type="number"
            id="max-budget"
            name="max-budget"
            value={filters.maxBudget}
            onChange={(e) => updateBudgetFilter('maxBudget', e.target.value)}
            className="mt-1 block w-full rounded-md ring-1 ring-inset ring-gray-300 dark:ring-gray-600 py-1.5 px-3 text-sm text-gray-900 dark:text-white shadow-sm focus:ring-2 focus:ring-inset focus:ring-indigo-600 dark:bg-gray-700"
            placeholder="Any"
          />
        </div>
      </div>
    </div>
  );
};

export default BudgetRangeFilter;